import { List, Create, Edit, Show, AddUser, TreeView, AddAppointments, TreeViewOrg, TreeAddEdit, Setup, AppointmentView, TreeCreate, TreeEdit, Auth } from "../Components/index.js";

export default [
    {
        path: "/admin/company-tree-add-edit",
        component: TreeAddEdit,
        name: "company-tree-add-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company-tree-org",
        component: TreeViewOrg,
        name: "company-tree.org",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/company",
        component: List,
        name: "company-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company/:company_id/show",
        component: Show,
        name: "company-show",

        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company/:company_id/edit",
        component: Edit,
        name: "company-edit",

        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company/:company_id/add-user",
        component: AddUser,
        name: "company.add.user",

        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company/:company_id/add-appointments",
        component: AddAppointments,
        name: "company.add.appointments",

        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company/appointments",
        component: AppointmentView,
        name: "company.appointments.map",

        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company-tree-view",
        component: TreeView,
        name: "company-tree",

        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company/create",
        component: Create,
        name: "company-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company/create-tree",
        component: TreeCreate,
        name: "company-create-tree",

        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company/edit-tree",
        component: TreeEdit,
        name: "company-edit-tree",

        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company/setup-tree",
        component: Setup,
        name: "company-setup-tree",

        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/company/auth",
        component: Auth,
        name: "admin-company-auth",
        meta: {
            requiresAuth: true,
        },
    },
];
